import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import formatBytes from '../../services/bytes';

/**
 *
 * @param {string}      fileName    - The name of the file
 * @param {string}      fileSize    - The size of the file
 * @param {function}    onRemove    - function to be called when the file remove button is clicked
 *
 * @returns {JSX.Element}           - The File component.
 */
export default function File({ fileName = '', fileSize = '', onRemove = () => {} }) {
  return (
    <>
      <div className="rounded-lg border border-2 p-2 font-medium">
        {fileName}
        <span className="px-3 font-light italic">{formatBytes(fileSize, 2)}</span>
        <IconButton color="error" sx={{ p: 0 }} onClick={() => onRemove({ name: fileName })}>
          <DeleteIcon />
        </IconButton>
      </div>
    </>
  );
}
